import React from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from "../styles/staticPages.js";
import Parallax from "components/Parallax/Parallax";
import { useTranslation } from "react-i18next";
import { colors } from "components/Theme/WebTheme.js";
import { getPrivacyPolicyContent } from "../content/privacyPolicyContent";

const dashboardRoutes = [];
const useStyles = makeStyles(styles);

const textClass = (classes, isRTL) =>
  isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription;

const SectionTitle = ({ children }) => (
  <p style={{ marginTop: "1.25em", marginBottom: "0.5em" }}>
    <strong>{children}</strong>
  </p>
);

const Para = ({ children, classes, isRTL }) => (
  <p className={textClass(classes, isRTL)}>{children}</p>
);

const BulletList = ({ items, classes, isRTL }) => (
  <ul
    className={textClass(classes, isRTL)}
    style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
  >
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);

const h2Style = (isRTL) => ({
  textAlign: isRTL === "rtl" ? "right" : "left",
  position: "relative",
  marginTop: "30px",
  minHeight: "32px",
  color: colors.Header,
  textDecoration: "none",
  marginRight: isRTL === "rtl" ? "30px" : "0px",
  wordBreak: "break-word",
});

function PolicySection({ section, classes, isRTL }) {
  return (
    <>
      <SectionTitle>{section.title}</SectionTitle>
      {section.paragraphs &&
        section.paragraphs.map((text) => (
          <Para key={text} classes={classes} isRTL={isRTL}>
            {text}
          </Para>
        ))}
      {section.listIntro && (
        <Para classes={classes} isRTL={isRTL}>
          {section.listIntro}
        </Para>
      )}
      {section.items && (
        <BulletList items={section.items} classes={classes} isRTL={isRTL} />
      )}
      {section.paragraphsAfter &&
        section.paragraphsAfter.map((text) => (
          <Para key={text} classes={classes} isRTL={isRTL}>
            {text}
          </Para>
        ))}
      {section.rightsContactPrefix && (
        <Para classes={classes} isRTL={isRTL}>
          {section.rightsContactPrefix}
          <a href="mailto:urba@urbaapp.com">urba@urbaapp.com</a>
          {section.rightsContactSuffix}
        </Para>
      )}
      {section.contactBlock && (
        <Para classes={classes} isRTL={isRTL}>
          {section.contactBlock.company}
          <br />
          {section.contactBlock.address}
          <br />
          {section.contactBlock.emailLabel}{" "}
          <a href="mailto:urba@urbaapp.com">urba@urbaapp.com</a>
          <br />
          {section.contactBlock.phoneLabel} (831) 402-2765
        </Para>
      )}
    </>
  );
}

export default function PrivacyPolicy(props) {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const content = getPrivacyPolicyContent(i18n.language);
  const { ...rest } = props;

  return (
    <div style={{ margin: "-8px" }}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg").default} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <br />
          <h2 style={h2Style(isRTL)}>{content.title}</h2>

          <Para classes={classes} isRTL={isRTL}>
            <strong>{content.meta.lastUpdated}</strong> {content.meta.lastUpdatedDate}
          </Para>
          <Para classes={classes} isRTL={isRTL}>
            <strong>{content.meta.serviceProvider}</strong>{" "}
            {content.meta.serviceProviderValue}
          </Para>
          <Para classes={classes} isRTL={isRTL}>
            <strong>{content.meta.website}</strong>{" "}
            <a href="https://www.urbaapp.com/">https://www.urbaapp.com/</a>
          </Para>
          <Para classes={classes} isRTL={isRTL}>
            <strong>{content.meta.contact}</strong>{" "}
            <a href="mailto:urba@urbaapp.com">urba@urbaapp.com</a> | (831) 402-2765
          </Para>
          <Para classes={classes} isRTL={isRTL}>
            <strong>{content.meta.address}</strong> {content.meta.addressValue}
          </Para>

          <Para classes={classes} isRTL={isRTL}>
            {content.intro}
          </Para>

          {content.sections.map((section) => (
            <PolicySection
              key={section.id}
              section={section}
              classes={classes}
              isRTL={isRTL}
            />
          ))}

          <SectionTitle>{content.disclosure.title}</SectionTitle>
          <Para classes={classes} isRTL={isRTL}>
            {content.disclosure.text}
          </Para>

          <br />
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
}
